
function clearErrors(form) {
  form.querySelectorAll(".form-field__error").forEach((el) => el.remove())
  form.querySelectorAll("[aria-invalid]").forEach((el) => {
    el.removeAttribute("aria-invalid")
    el.removeAttribute("aria-describedby")
  })
}

function showErrors(form, errors) {
  Object.entries(errors || {}).forEach(([name, message]) => {
    const input = form.elements.namedItem(name)
    if (!(input instanceof HTMLElement) || !input.id) return

    const note = document.createElement("p")
    note.className = "form-field__error"
    note.id = `${input.id}-error`
    note.textContent = message

    input.setAttribute("aria-invalid", "true")
    input.setAttribute("aria-describedby", note.id)
    input.insertAdjacentElement("afterend", note)
  })

  form.querySelector("[aria-invalid]")?.focus()
}

function showFailure(form) {
  const note = document.createElement("p")
  note.className = "form-field__error"
  note.setAttribute("role", "alert")
  note.textContent = "Something went wrong. Please try again."
  form.querySelector('[type="submit"]')?.insertAdjacentElement("beforebegin", note)
}

async function submit(form) {
  const button = form.querySelector('[type="submit"]')
  if (button) button.disabled = true
  clearErrors(form)

  try {
    const response = await fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
    const data = await response.json()

    if (!data.success) {
      showErrors(form, data.errors)
      return
    }

    const content = form.querySelector("[data-lead-form-content]")
    const thanks = form.querySelector("[data-lead-form-thanks]")
    if (content) content.hidden = true
    if (thanks) {
      thanks.hidden = false
      thanks.focus()
    }
  } catch (error) {
    showFailure(form)
  } finally {
    if (button) button.disabled = false
  }
}

export function initForms() {
  document.querySelectorAll("form[data-lead-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault()
      submit(form)
    })
  })
}
